<template>
  <div class="dealer-dashboard">
    <PageHeader :breadcrumbs="breadcrumbs" icon="mdi-storefront-outline" />

    <v-row>
      <v-col cols="8">
        <DealerStatsCards :stats="stats" class="mb-4" />
        <DealerRecentOrders :orders="recentOrders" />
      </v-col>

      <v-col cols="4">
        <!-- Quick actions -->
        <v-card class="mb-4">
          <v-card-title class="subtitle-1">{{ $t('dealer.dashboard.quickActions') }}</v-card-title>
          <v-card-text>
            <v-btn block color="primary" :to="{ name: 'DealerOrders' }">
              {{ $t('dealer.dashboard.manageOrders') }}
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- Messages (coming soon) -->
        <v-card class="mb-4" style="opacity: 0.5; pointer-events: none;">
          <v-card-title class="subtitle-1">
            {{ $t('dealer.dashboard.messages') }}
            <v-chip x-small class="ml-2">{{ $t('dealer.dashboard.comingSoon') }}</v-chip>
          </v-card-title>
          <v-card-text>{{ $t('dealer.dashboard.messagesDesc') }}</v-card-text>
        </v-card>

        <!-- Inventory (coming soon) -->
        <v-card class="mb-4" style="opacity: 0.5; pointer-events: none;">
          <v-card-title class="subtitle-1">
            {{ $t('dealer.dashboard.inventory') }}
            <v-chip x-small class="ml-2">{{ $t('dealer.dashboard.comingSoon') }}</v-chip>
          </v-card-title>
          <v-card-text>{{ $t('dealer.dashboard.inventoryDesc') }}</v-card-text>
        </v-card>

        <!-- Calendar (coming soon) -->
        <v-card style="opacity: 0.5; pointer-events: none;">
          <v-card-title class="subtitle-1">
            {{ $t('dealer.dashboard.calendar') }}
            <v-chip x-small class="ml-2">{{ $t('dealer.dashboard.comingSoon') }}</v-chip>
          </v-card-title>
          <v-card-text>{{ $t('dealer.dashboard.calendarDesc') }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import DealerStatsCards from '@/components/DealerStatsCards';
import DealerRecentOrders from '@/components/DealerRecentOrders';

export default {
  name: 'DealerDashboard',

  components: {
    PageHeader,
    DealerStatsCards,
    DealerRecentOrders,
  },

  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('dealer.dashboard.title'),
          exact: true,
          to: { name: 'DealerDashboard' },
        },
      ];
    },

    stats() {
      return this.$store.getters['dealerOrders/dealerStats'];
    },

    recentOrders() {
      const orders = this.$store.getters['dealerOrders/dealerOrders'] || [];
      return [...orders]
        .sort((a, b) => {
          const dateA = new Date(a.orderPlacedAt || 0).getTime();
          const dateB = new Date(b.orderPlacedAt || 0).getTime();
          return dateB - dateA;
        })
        .slice(0, 5);
    },
  },
};
</script>
